// extracted by mini-css-extract-plugin
export default {"aboutContainer":"About_aboutContainer__AiE9L","pageHeader":"About_pageHeader__codxv","grainsImage":"About_grainsImage__wiI5e"};